import Button from 'components/Forms/Button/Button';
import { ProductListPopup } from 'components/Pages/Configurator/Popup/ProductList/ProductListPopup';
import useTranslation from 'next-translate/useTranslation';
import { memo } from 'react';
import { usePersistStore } from 'store/usePersistStore';
import { useSessionStore } from 'store/useSessionStore';

const ShowProductListButton = () => {
    const { t } = useTranslation();
    const { productsInDrawer } = usePersistStore();
    const updatePortalContent = useSessionStore((s) => s.updatePortalContent);

    const onCloseCallback = () => {
        updatePortalContent(null);
    };

    const openPopupHandler = () => {
        updatePortalContent(<ProductListPopup onCloseCallback={onCloseCallback} />);
    };

    return (
        <>
            <Button
                className="h-fit w-fit whitespace-nowrap vl:text-h6"
                isDisabled={productsInDrawer.length === 0}
                size="small"
                type="button"
                onClick={openPopupHandler}
            >
                {t('Product list')}
            </Button>
        </>
    );
};

ShowProductListButton.displayName = 'ShowProductListButton';
export default memo(ShowProductListButton);
